export const activeContactIdQueryParam = 'contactId';

export const searchValueQueryParam = 'search';
